export function canCancelTimeOffRow({ status, canRrhh }) {
  if (canRrhh) return status === "pending" || status === "approved";
  return status === "pending";
}

export function canChangeTimeOffTypeRow({ status, canRrhh }) {
  return !!canRrhh && (status === "pending" || status === "approved");
}
